import React from 'react'
import { useTranslation } from 'react-i18next'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import RecoverMyPasswordForm from '../components/form/RecoverMyPasswordForm'
import { resetPassword } from '../store/passwordRecovery/actions'

const RecoverMyPasswordPage = ({ match, lang }) => {
  const { t } = useTranslation()

  return (
    <div>
      <RecoverMyPasswordForm
        lang={lang}
        translation={t}
        token={match.params.token}
        history={history}
      />
    </div>
  )
}

const mapStateToProps = ({ auth }) => ({
  lang: auth.lang
})

const mapDispatchToPros = dispatch => bindActionCreators({ resetPassword }, dispatch)

export default connect(mapStateToProps, mapDispatchToPros)(RecoverMyPasswordPage)
